/* eslint-disable */
import { EventEmitter, Type } from "@angular/core";
import { assign, cloneDeep } from "lodash-es";
import { v1 as uuid } from "uuid";
import { ComparisonExpression, Conditional } from "./expression-settings/model";

export class FormDefinition {
    type = "vform";

    title: string;

    description: string;

    fields: Field[] = [];

    excludedFields: string[];

    requiredDescription: boolean;

    conditionals: Conditional[] = [];

    addField(field: Field, index: number = this.fields.length) {
        field.id = uuid();
        this.fields.splice(index, 0, field);
    }

    delete(field: Field) {
        const index = this.fields.indexOf(field);

        if (index >= 0) {
            this.fields.splice(index, 1);
        }
    }

    duplicate(field: Field) {
        const duplicatedField = cloneDeep(field);
        this.addField(duplicatedField, this.fields.indexOf(field) + 1);
    }

    get valid() {
        return this.title && this.title.length > 0 && this.fields.length > 0;
    }

    get isVForm() {
        return this.type === "vform";
    }

    addConditional(conditional: Conditional) {
        this.conditionals.push(conditional);
    }
}

export enum ComparisonOperator {
    Equal = "=",
    NotEqual = "!=",
    LessThan = "<",
    EqualOrLessThan = "<=",
    GreaterThan = ">",
    EqualOrGreaterThan = ">=",
    Empty = "empty",
    NotEmpty = "!empty",
    Contains = "contains",
    NotContains = "!contains",

    Today = "today",
    Yesterday = "yesterday",
    CurrentWeek = "week",
    LastWeek = "last-week",
    CurrentMonth = "month",
    LastMonth = "last-month",
    CurrentYear = "year",
    LastYear = "last-year",
}

export enum ComparatorPickerType {
    None = "none",
    Text = "text",
    Number = "number",
    Date = "date",
    Datetime = "datetime",
    Selection = "selection",
    Cid10Selection = "cid10-selection",
}

export class ComparatorPicker {
    type: ComparatorPickerType;

    values: any;

    constructor(type: ComparatorPickerType, values: any = undefined) {
        this.type = type;
        this.values = values;
    }
}

export abstract class ComparatorPickerBuilder {
    abstract build(comparisonExpression: ComparisonExpression): ComparatorPicker;
}

export abstract class FieldType {
    id: string;

    title: string;

    icon: string;

    description: string;

    previewComponent: Type<any>;

    editorComponent: Type<any>;

    abstract createField(): Field;

    supportedComparisonOperators(): ComparisonOperator[] {
        return [ComparisonOperator.Empty, ComparisonOperator.NotEmpty];
    }

    evaluate(expression: ComparisonExpression, value: any): boolean {
        if (expression.operator === ComparisonOperator.Empty && !value) {
            return true;
        }

        if (expression.operator === ComparisonOperator.NotEmpty && value) {
            return true;
        }

        return false;
    }
}

export abstract class Field {
    id: string;

    type: FieldType;

    label: string;

    description: string;

    classes: string[] = [];

    required = false;

    //Field will be marked as deleted
    deleted = false;

    onChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

    onInvalid: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(type: FieldType) {
        this.type = type;
    }

    get icon() {
        return this.type.icon;
    }

    protected validate(value: any): true {
        return true;
    }

    update(value: any) {
        if (this.validate(value)) {
            assign(this, value);
            this.onChanged.emit(true);
        } else {
            this.onInvalid.emit(true);
        }
    }

    toJson() {
        return {
            id: this.id,
            typeId: this.type.id,
            label: this.label,
            description: this.description,
            required: this.required,
            classes: this.classes,
        };
    }
}
